export default {
  title: 'Choix de scénario',
  titleHint: '',
  titleSection: 'Récapitulatif du scénario',
  numbers: {
    title: 'Les chiffres de votre transmission',
    text: 'Visualisez, ci-dessous, l\'évolution de vos indicateurs determinant l\'impact sur votre scénario de transmission en fonction des choix effectués jusqu\'à présent dans votre simulation :'
  },
  impacts: {
    title: 'Impacts sur votre transmission',
    hint: 'La valeur des biens et capitaux décès reçus en usufruit ou en nue-propriété est exprimée en valeur pleine propriété.',
    text: 'Visualisez, ci-dessous, l\'évolution de vos indicateurs determinant l\'impact sur votre scénario de transmission en fonction des choix effectués jusqu\'à présent dans votre simulation :',
    options: {
      currentSituation: 'Situation actuelle',
      afterSimulation: 'Après simulation'
    }
  }
}
